import PropTypes from 'prop-types';
import { memo } from 'react';
// -*- mode: jsx;-*-
import { ProjectDataList } from './ProjectDataList.js';
import { ProgressBar } from './ProgressBar.js';
import { MatchOfferInfo } from './MatchOfferInfo.js';
import { AddToProjectFavoritesWidget, FAVORITES_STYLE } from './addToProjectFavoritesWidget.js';
import { AddToChallengeWidget } from './addToChallengeWidget.js';
import { GiveWidget } from './GiveWidget.js';
import { makeTeacherAndSchoolInfo } from './projectUtils.js';
import { projectFormatter } from './projectFormatter.js';

import '../../external/npm/html5-entities.js';


export let ProjectCard = function (props) {
    const project = props.project;
    const defaultImage = baseCacheURL + 'images/classroom/fallback-photo1@2x.png';
    // CAN WE RANDOMIZE THIS FALLBACK PHOTO SO IT CHOOSES 1-8?

    function makeDescription() {
        const desc = projectFormatter.formatMyStudentsNeed(project);
        return (
            <div className="project-description"
                dangerouslySetInnerHTML={{ __html: desc }}>
            </div>
        );
    }
    function getCardClassString(incomplete, imageURL) {
        if (!props.hideMatchOffer) {
            var matching = project.matchingFund;
            var matchTypeClass = matching.type === 'ALMOST_HOME'
                ? 'match-ah' : 'match-dyi';
            var mainMatchingKey = (props.mainMatch || {}).matchingKey;

            // We have an override-matching if the caller passed in a mainMatch
            // (like when, say, the user's searching for projects covered by a
            // specific match) and that mainMatch isn't the projects
            // "matchingFund".
            const hasOverride = (matching && matching.type && mainMatchingKey != matching.matchingKey);
            if (!hasOverride && !incomplete) {
                matching = project.completedMatching;
            }
        }

        let cardClassString = 'project-card ';
        cardClassString += imageURL === defaultImage ? 'no-photo' : 'has-photo';

        if (matching && matching.type) {
            cardClassString += ' ' + matchTypeClass;
            if (mainMatchingKey != matching.matchingKey) {
                cardClassString += ' with-match';
            }
        }
        if (!incomplete) {
            cardClassString += ' funded-project';
        }
        cardClassString += props.project.equityFocus ? ' equity-focus-classroom' : ' non-efs';
        return cardClassString;
    }

    var incomplete = parseFloat(project.costToComplete) > 0;
    var proposalURL = props.projectURLOverride ? props.projectURLOverride : projectFormatter.removeUTMParams(project.proposalURL);
    var imageURL = project.imageURL || defaultImage;
    var numDonors = props.numDonorsOverride ? props.numDonorsOverride : project.numDonors;
    var cardClassString = getCardClassString(project, incomplete, imageURL);

    if (incomplete) {
        var giveWidget = <GiveWidget {...props} projectId={project.id}/>;
        var addToChallengeWidget = <AddToChallengeWidget {...props} />;
    }

    if (!props.hideClassroomPhoto) {
        var classroomPhoto =
                <div className="col col3 desktop">
                    <div className="classroom-photo" style={{ backgroundImage: 'url(' + imageURL + ')' }}>
                        <AddToProjectFavoritesWidget
                            projectId={parseInt(project.id)}
                            isEligibleForFunding={incomplete}
                            initFavStatus={false}
                            userId={parseInt(window.userId)}
                            favoritesStyle={FAVORITES_STYLE.heart}
                            handleRemoveFavorite={props.handleRemoveFavorite}
                            alwaysShowFavoritesWidget={props.alwaysShowFavoritesWidget}
                        />
                    </div>
                </div>;
    }

    const isMatch = props.project.matchingFund && props.project.matchingFund.type;

    return (
        <div className={isMatch ? 'matched' : ''}>
            <div className={cardClassString}>
                <a className='project-page-link' href={proposalURL}></a>
                <MatchOfferInfo
                    project={project}
                    mainMatch={props.mainMatch}
                    hideMatchOffer={props.hideMatchOffer}
                    numDonors={parseInt(numDonors)}
                    fullyFunded={!incomplete}
                />
                <div>
                    <div className="fluid-container">
                        {classroomPhoto}
                        <div className={'col ' + (props.hideClassroomPhoto ? 'col8' : 'col6')}>
                            {project.professionalDevelopment ? <span className={'project-type-badge professional-dev' + (props.hideClassroomPhoto ? ' photo-hidden' : '')}>Professional development</span> : ''}
                            <h3
                                dangerouslySetInnerHTML={{ __html: project.title }}>
                            </h3>
                            <span className={(props.hideClassroomPhoto ? '' : 'mobile')}>
                                <AddToProjectFavoritesWidget
                                    projectId={parseInt(project.id)}
                                    isEligibleForFunding={true}
                                    initFavStatus={false}
                                    userId={parseInt(window.userId)}
                                    favoritesStyle={FAVORITES_STYLE.heart}
                                    handleRemoveFavorite={props.handleRemoveFavorite}
                                    alwaysShowFavoritesWidget={props.alwaysShowFavoritesWidget}
                                />
                            </span>
                            {makeDescription()}
                            <div className="intro">
                                {makeTeacherAndSchoolInfo(project)}
                            </div>
                        </div>
                        <div className={'col ' + (props.hideClassroomPhoto ? 'col4' : 'col3')}>
                            <ProgressBar project={project} />
                            <ProjectDataList
                                project={project}
                                incomplete={incomplete}
                                numDonors={parseInt(numDonors)}
                                hideExpiration={props.hideExpiration}
                                isEligibleForPrefunding={props.isEligibleForPrefunding}
                            />
                            {giveWidget}
                            {addToChallengeWidget}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ProjectCard.propTypes = {
    project: PropTypes.object.isRequired,

    projectURLOverride: PropTypes.string,
    numDonorsOverride: PropTypes.string,
    hideMatchOffer: PropTypes.bool,
    hideExpiration: PropTypes.bool,
    mainMatch: PropTypes.object,
    isEligibleForPrefunding: PropTypes.bool,
    hideClassroomPhoto: PropTypes.bool,
    handleRemoveFavorite: PropTypes.func,
    alwaysShowFavoritesWidget: PropTypes.bool,
    // See documentation on GiveWidget.
    portalTarget: PropTypes.instanceOf(window.Element),
};

ProjectCard = memo(ProjectCard);
